import React from 'react';

const EmptyTaskImage = ({ onAddTask, isCompletedView }) => {
  return (
    <div className="flex flex-col items-center justify-center h-[500px] w-full">
      {isCompletedView? (<svg
        width="400"
        height="400"
        viewBox="0 0 400 400"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="mb-8"
      >
        {/* Stars */}
        {[...Array(50)].map((_, i) => (
          <circle
            key={i}
            cx={Math.random() * 400}
            cy={Math.random() * 400}
            r={Math.random() * 2 + 0.5}
            fill="#3182CE"
            opacity={Math.random() * 0.8 + 0.2}
          />
        ))}

        {/* Mars */}
        <circle cx="200" cy="200" r="150" fill="#F97316" />
        <circle cx="200" cy="200" r="145" fill="#EA580C" />

        {/* Mars surface features */}
        <path d="M100 150 Q150 100 200 150 T300 200 Q250 250 150 200 Z" fill="#C2410C" />
        <path d="M50 250 Q100 200 150 250 T250 300 Q200 350 100 300 Z" fill="#C2410C" />

        {/* Craters */}
        <circle cx="150" cy="150" r="20" fill="#9A3412" />
        <circle cx="280" cy="220" r="15" fill="#9A3412" />
        <circle cx="180" cy="280" r="25" fill="#9A3412" />

        {/* Polar ice cap */}
        <path d="M170 60 Q200 50 230 60 T260 80 Q230 100 170 80 Z" fill="#F7FAFC" />

        {/* Thin atmosphere */}
        <circle cx="200" cy="200" r="155" stroke="#FDBA74" strokeWidth="5" opacity="0.3" />

        {/* Floating Astronaut */}
        <g transform="translate(180, 140) rotate(15)">
          <circle cx="0" cy="0" r="40" fill="#F7FAFC" /> {/* Helmet */}
        {/* Base dark tinted shield */}
  <circle cx="0" cy="0" r="35" fill="#1A1F2E">
    <animate attributeName="fill" values="#1A1F2E; #2C3E50; #1A1F2E" dur="4s" repeatCount="indefinite" />
  </circle>

  {/* Glossy highlight overlay */}
  <path
    d="M -20 -25 Q 0 -40 20 -25"
    fill="none"
    stroke="white"
    strokeOpacity="0.25"
    strokeWidth="4"
  />
  <path
    d="M -15 5 Q 0 -10 15 5"
    fill="none"
    stroke="white"
    strokeOpacity="0.1"
    strokeWidth="2"
  />
      
          <rect x="-20" y="10" width="40" height="60" rx="20" fill="#F7FAFC" /> {/* Body */}
          <rect x="-25" y="40" width="50" height="20" rx="10" fill="#4299E1" /> {/* Belt */}
          <rect x="-40" y="10" width="20" height="40" rx="10" fill="#F7FAFC" /> {/* Left arm */}
          <rect x="20" y="10" width="20" height="40" rx="10" fill="#F7FAFC" /> {/* Right arm */}
          <rect x="-15" y="70" width="15" height="30" rx="7.5" fill="#F7FAFC" /> {/* Left leg */}
          <rect x="0" y="70" width="15" height="30" rx="7.5" fill="#F7FAFC" /> {/* Right leg */}
        </g>

        {/* Empty task list hologram */}
        <g opacity="0.6">
          <rect x="250" y="260" width="100" height="70" rx="5" fill="#4299E1" />
          <text x="270" y="300" fill="#EBF8FF" fontSize="14">No Tasks...</text>
        </g>
      </svg>) : ( <svg
        width="400"
        height="400"
        viewBox="0 0 400 400"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        {/* Stars */}
        {[...Array(50)].map((_, i) => (
          <circle
            key={i}
            cx={Math.random() * 400}
            cy={Math.random() * 400}
            r={Math.random() * 4 + 1.5}
            fill="#3182CE"
            opacity={Math.random() * 0.8 + 0.2}
          />
        ))}

         {/* Mars */}
         <circle cx="200" cy="200" r="150" fill="#F97316" />
        <circle cx="200" cy="200" r="145" fill="#EA580C" />

        {/* Mars surface features */}
        <path d="M100 150 Q150 100 200 150 T300 200 Q250 250 150 200 Z" fill="#C2410C" />
        <path d="M50 250 Q100 200 150 250 T250 300 Q200 350 100 300 Z" fill="#C2410C" />

        {/* Craters */}
        <circle cx="150" cy="150" r="20" fill="#9A3412" />
        <circle cx="280" cy="220" r="15" fill="#9A3412" />
        <circle cx="180" cy="280" r="25" fill="#9A3412" />

        {/* Polar ice cap */}
        <path d="M170 60 Q200 50 230 60 T260 80 Q230 100 170 80 Z" fill="#F7FAFC" />

        {/* Thin atmosphere */}
        <circle cx="200" cy="200" r="155" stroke="#FDBA74" strokeWidth="5" opacity="0.3" />


        {/* Levitating Astronaut */}
        <g transform="translate(40, 60) scale(0.8)"> {/* Moved higher on the canvas */}
  {/* Helmet */}
  <circle cx="100" cy="100" r="40" fill="#F7FAFC" /> 

  {/* Face shield with dark tint and animated fill */}
  <g>
    <circle cx="100" cy="100" r="35" fill="#1A1F2E">
      <animate attributeName="fill" values="#1A1F2E; #2C3E50; #1A1F2E" dur="4s" repeatCount="indefinite" />
    </circle>
    {/* Glossy highlight streaks */}
    <path
      d="M 80 85 Q 100 70 120 85"
      fill="none"
      stroke="white"
      strokeOpacity="0.25"
      strokeWidth="3"
    />
    <path
      d="M 85 105 Q 100 90 115 105"
      fill="none"
      stroke="white"
      strokeOpacity="0.1"
      strokeWidth="2"
    />
  </g>

  {/* Body and limbs */}
  <rect x="80" y="110" width="40" height="60" rx="20" fill="#F7FAFC" />
  <rect x="75" y="140" width="50" height="20" rx="10" fill="#4299E1" />
  <rect x="60" y="110" width="20" height="40" rx="10" fill="#F7FAFC" /> {/* Left arm */}
  <rect x="120" y="110" width="20" height="40" rx="10" fill="#F7FAFC" /> {/* Right arm */}
  <rect x="85" y="170" width="15" height="30" rx="7.5" fill="#F7FAFC" /> {/* Left leg */}
  <rect x="100" y="170" width="15" height="30" rx="7.5" fill="#F7FAFC" /> {/* Right leg */}
</g>


        {/* Empty task list hologram */}
        <g opacity="0.6">
          <rect x="250" y="260" width="100" height="80" rx="5" fill="#4299E1" />
          <line x1="260" y1="280" x2="340" y2="280" stroke="#EBF8FF" strokeWidth="2" />
          <line x1="260" y1="300" x2="340" y2="300" stroke="#EBF8FF" strokeWidth="2" />
          <line x1="260" y1="320" x2="340" y2="320" stroke="#EBF8FF" strokeWidth="2" />
        </g>
      </svg>)}
    

      <h2 className="text-2xl font-bold text-gray-800 mt-6">
        {isCompletedView ? 'Your Martian Task Frontier' : 'Your task landscape awaits!'}
      </h2>
      <p className="text-lg text-gray-600 mt-3">
        {isCompletedView ? 'Floating in the void' : 'Take one giant leap for your productivity.'}
      </p>
      {!isCompletedView && (
        <button
          className="mt-6 px-6 py-3 bg-[#4299E1] text-white rounded-full font-semibold hover:bg-[#3182CE] transition-colors duration-300"
          onClick={onAddTask}
        >
          Create Your First Task
        </button>
      )}
    </div>
  );
};

export default EmptyTaskImage;
